export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-8-b1e52d343a115527ca3d037ce486ca58.png";